    const mainCol = '#9f9f9f';
    const colWat = '#e5e3df'; //water
    const colTer = '#dddddd';
    const colCities = mainCol;
    const colRoads = mainCol;
    const colLand = mainCol;
    const colTextFill = '#222222';
    const colTextStrk = mainCol;


    // Create a new StyledMapType object, passing it an array of styles,
    // and the name to be displayed on the map type control.
    const styledMapType = new google.maps.StyledMapType(
        [
        {elementType: 'geometry', stylers: [{color: colCities}]},
        {elementType: 'labels.text.fill', stylers: [{color: colTextFill}]},
        {elementType: 'labels.text.stroke', stylers: [{color: colTextStrk}]},
        {
            featureType: 'administrative',
            elementType: 'geometry.stroke',
            stylers: [{color: colTer}]
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'geometry.stroke',
            stylers: [{color: colWat}]
        },
        {
            featureType: 'administrative.land_parcel',
            elementType: 'labels.text.fill',
            stylers: [{color: colWat}]
        },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [{color: colLand}]
        },
        {
            featureType: 'poi',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'poi',
            elementType: 'labels.text.fill',
            stylers: [{color: colTer}]
        },
        {
            featureType: 'poi.park',
            elementType: 'geometry.fill',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'poi.park',
            elementType: 'labels.text.fill',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.highway.controlled_access',
            elementType: 'geometry.stroke',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'road.local',
            elementType: 'labels.text.fill',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'transit.line',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.fill',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'transit.line',
            elementType: 'labels.text.stroke',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'transit.station',
            elementType: 'geometry',
            stylers: [{color: colRoads}]
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [{color: colWat}]
        },
        {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{color: colWat}]
        }
        ],
        {name: 'Map'});